const pageSeo = {
  'it': {
    title: 'Pane e prodotti surgelati per bar, paninoteche, catering e ristoranti | Glaxi Pane',
    description: 'Glaxi Pane produce pane e prodotti da forno surgelati per la ristorazione unendo le sapienti tradizioni familiari alle più avanzate tecnologie.',
    hreflang: '/it/'
  },
  'en': {
    title: 'Bread and frozen products for bars, sandwich bars, catering and restaurants | Glaxi Pane',
    description: 'Glaxi Pane produces bread and frozen bakery products for catering, combining the expert family traditions together with the most advanced technologies.',
    hreflang: '/en/'
  }
}
export default pageSeo
